<template>
  <i class="iconfont" :class="`icon-${name}`" :style="{fontSize: `${fontSize}px`, color: color, marginLeft: `${marginLeft}px`, marginRight: `${marginRight}px`, cursor: cursor ? 'pointer' : 'auto'}"></i>
</template>

<script>
export default {
  name: "iconFont",
  props: {
    name: {
      type: String,
      default: '',
    },
    fontSize: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    cursor: {
      type: Boolean,
      default: false,
    }
  }
};
</script>

<style scoped lang="scss">
</style>